import React from "react";
import { Link } from "react-router-dom";
import "../../styles/empreendimentosStyle/CardEmpreendimento.css";
import { BASE_URL2 } from "../../API/api2";

interface CardEmpreendimentoProps {
  empreendimento: {
    id: number;
    nome: string;
    imagens: string[]; // <- array de strings do backend
    valor_medio?: string;
    tabela_preco?: string;
    endereco?: {
      municipio?: string;
      bairro?: string;
    };
  };
}

export default function CardEmpreendimento({ empreendimento }: CardEmpreendimentoProps) {
  // Pega a primeira imagem do array ou placeholder se estiver vazio
  const imagemExibicao = empreendimento.imagens?.[0]
  ? empreendimento.imagens[0]
  : "/placeholder.jpg";
  console.log(imagemExibicao)
  

  return (
    <Link
      to={`/empreendimentos/${empreendimento.id}`}
      state={{ empreendimento }} // envia o array completo
      className="card-link"
    >
      <div className="card-container">
        <img src={imagemExibicao} alt={empreendimento.nome} className="card-imagem" />
        <div className="card-infos">
          <h4>{empreendimento.nome}</h4>
          <span className="card-preco">
            Média: R$ {empreendimento.valor_medio ?? "Sob consulta"}
          </span>
          <p>
            {empreendimento.endereco?.municipio},{" "}
            {empreendimento.endereco?.bairro}
          </p>
        </div>
      </div>
    </Link>
  );
}
